import { Component } from '@angular/core';

@Component({
  selector: 'app-compat-tracking',
  template: `
    <fl-navigation-performance-tracking></fl-navigation-performance-tracking>
    <fl-user-timing-tracking></fl-user-timing-tracking>
    <fl-memory-leak-tracking></fl-memory-leak-tracking>
    <fl-synthetic-performance-tracking></fl-synthetic-performance-tracking>
  `
})
export class CompatTrackingComponent {
}



// WEBPACK FOOTER //
// ./src/compat/compat-tracking.component.ts